import useSWR, { SWRConfiguration, BareFetcher, Key } from 'swr';

import { apiFetch } from './api';

/**
 * Default SWR fetcher using our API client
 */
export const fetcher: BareFetcher<unknown> = (url: string) => apiFetch(url);

/**
 * Default SWR configuration
 */
export const swrConfig: SWRConfiguration = {
  fetcher,
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  shouldRetryOnError: (error) => {
    // Don't retry on 4xx errors
    if (error?.status >= 400 && error?.status < 500) {
      return false;
    }
    return true;
  },
  errorRetryCount: 3,
  errorRetryInterval: 1000,
};

/**
 * Typed SWR hook wrapper
 */
export function useApi<T = unknown>(
  key: Key,
  config?: SWRConfiguration<T>
) {
  return useSWR<T>(key, fetcher as BareFetcher<T>, { ...swrConfig, ...config });
}